import React from "react";
import ReactDataGrid from "react-data-grid";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import * as moment from "moment";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

import { PaymentModal } from "../PaymentModalPage";
import { userService, dataService, cardsService, creditCardService, genericCodesService } from "../_services";

class InvoicesComponent_ extends React.Component {
  constructor(props) {
    super(props);
    this._columns = [
      {
        key: "INVOICE_NO",
        name: this.props.t("invoice_number"),
        width: 95,
        resizable: false,
      },
      {
        key: "INV_SUM",
        name: this.props.t("invoice_sum"),
        formatter: (data) => {
          return (
            <span className="colorRed">
              {data.value
                ? data.value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")
                : "0"}
            </span>
          );
        },
        width: 100,
        resizable: false,
      },
      {
        key: "HNAME",
        name: this.props.t("branch_name"),
        width: 140,
        resizable: false,
      },
      {
        key: "INV_CRE_DATE",
        name: this.props.t("invoice_creation_date"),
        formatter: (data) => {
          return (
            <span>
              {data.value ? moment(data.value).format("DD/MM/YY") : ""}
            </span>
          );
        },
        width: 85,
        resizable: false,
      },
    ];

    let user = userService.getUser();
    let card = cardsService.getCardfromSessionStorage();
    let rows = []; //props.rows;

    this.state = {
      rows,
      selectedIndexes: [],
      inv_list: [],
      inv_sum: 0,
      user,
      //card: card,
      // card: this.props.card.ID ? this.props.card : card,
      modalShow: false,
      zCreditUrl: "",
      actual_pay_sum: 0,
      actual_pay_sum_valid: false,
      payments_no: 1,
      pinpad: ''
    };
    this.getInvoices(card);
    this.handleActualPaySumChange = this.handleActualPaySumChange.bind(this);
    this.handlPaymentsNoChange = this.handlPaymentsNoChange.bind(this);
  }

  getInvoices = (inCard) => {
    const user = this.state.user;
    const card = inCard || this.props.card;
    if (user && user.token && card && card.ID) {
      dataService.getInvoices(card.ID, "O", user.token).then((invoices) => {
        console.log(invoices);
        // PIGOR_PYM_ORDER
        const inv_list = [];
        const selectedIndexes = [];
        let inv_sum = 0;
        invoices.forEach( (inv,rowIdx) => {
          if (inv.PIGOR_PYM_ORDER === 100) {
            selectedIndexes[rowIdx] = rowIdx;
            inv_list[rowIdx] = inv.INVOICE_NO;
            inv_sum = inv_sum + inv.INV_SUM;
          }
        });
        console.log("selectedIndexes");
        console.log(selectedIndexes);
        this.setState({
          selectedIndexes: selectedIndexes,
          inv_list: inv_list,
          inv_sum: inv_sum,
          actual_pay_sum: inv_sum,
          rows: invoices,
        });
        
        console.log("this.state");
        console.log(this.state);
        return invoices;
      });
    }
  };

  setSelectedRowsHanlde = () => {
    this.props.getSelectedRows({
      inv_list: this.state.inv_list.join(","),
      inv_sum: this.state.inv_sum,
      actual_pay_sum: this.state.inv_sum,
    });
    this.setState({
      actual_pay_sum_valid:
        this.state.actual_pay_sum > 0 &&
        this.state.actual_pay_sum <= this.state.inv_sum,
    });
  };

  rowGetter = (i) => {
    return this.state.rows[i];
  };

  onRowsSelected = (rows) => {
    this.setState(
      {
        selectedIndexes: this.state.selectedIndexes.concat(
          rows.map((r) => r.rowIdx)
        ),
        inv_list: this.state.inv_list.concat(
          rows.map((r) => r.row?.INVOICE_NO || null)
        ),
        inv_sum:
          this.state.inv_sum +
          rows.map((r) => r.row.INV_SUM).reduce((a, b) => a + b, 0),
        actual_pay_sum:
          this.state.inv_sum +
          rows.map((r) => r.row.INV_SUM).reduce((a, b) => a + b, 0),
      },
      this.setSelectedRowsHanlde
    );

    console.log("%c Rows:", "background: #222; color: #bada55");
    console.log(rows);
    console.log("this.state");
    console.log(this.state);
  };

  onRowsDeselected = (rows) => {
    let rowIndexes = rows.map((r) => r.rowIdx);
    this.setState(
      {
        selectedIndexes: this.state.selectedIndexes.filter(
          (i) => (rowIndexes.indexOf(i) === -1) || (this.state.rows[i].PIGOR_PYM_ORDER === 100)
        ),
        inv_list: this.state.selectedIndexes
          .filter((i) => (rowIndexes.indexOf(i) === -1) || (this.state.rows[i].PIGOR_PYM_ORDER === 100))
          .map((item) => {
            return this.state.rows[item].INVOICE_NO;
          }),
        inv_sum: this.state.selectedIndexes
          .filter((i) => (rowIndexes.indexOf(i) === -1) || (this.state.rows[i].PIGOR_PYM_ORDER === 100))
          .map((item) => {
            return this.state.rows[item].INV_SUM;
          })
          .reduce((a, b) => a + b, 0),
        actual_pay_sum: this.state.selectedIndexes
          .filter((i) => (rowIndexes.indexOf(i) === -1) || (this.state.rows[i].PIGOR_PYM_ORDER === 100))
          .map((item) => {
            return this.state.rows[item].INV_SUM;
          })
          .reduce((a, b) => a + b, 0),
      },
      this.setSelectedRowsHanlde
    );
  };

  handlecreateSession = () => {
    const payLoadObj = { ...this.state.user };
    creditCardService
      .createSession({
        card_id: this.props.card.ID,
        token: this.state.user.token,
        item_list: this.state.inv_list.join(","),
        item_sum: this.state.actual_pay_sum,
        card_full_name: this.props.card.H_FULL_NAME,
        client_url_origin: window.location.origin,
        item_type: "invoice",
        payLoadObj,
        paymentType: "regular",
      })
      .then((data) => {
        console.log(data);
        //window.open(data.url, "_blank");
        this.setState({ modalShow: true, zCreditUrl: data.url });
      })
      .catch((error) => {
        console.error("Error:", error);
        return { error: true, message: error.toString() };
      });
  };

  handlePinpadSelect = (e) => {
    const payLoadObj = { ...this.state.user };
    creditCardService
      .pinpadCommitFullTransaction({
        card_id: this.props.card.ID,
        token: this.state.user.token,
        item_list: this.state.inv_list.join(","),
        item_sum: this.state.actual_pay_sum,
        payments_no: this.state.payments_no,
        card_full_name: this.props.card.H_FULL_NAME,
        client_url_origin: window.location.origin,
        item_type: "invoice",
        payLoadObj,
        paymentType: "regular",
        pinpad: e,
      })
      .then((data) => {
        console.log(data);
        if (data.error || !data.success) {
          toast.error(data.message || this.props.t("transaction_not_applyed"));
        } else {
          const reciept_url = `${window.location.origin}/credit_card?UniqueID=${data.UniqueID}&PaymentType=regular`;
          //window.open(reciept_url, "_blank");
          this.setState({ modalShow: true, zCreditUrl: reciept_url });
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error(this.props.t("transaction_not_applyed"));
        return { error: true, message: error.toString() };
      });
  };

  componentDidMount() {
    genericCodesService.getPinpad().then(pinpadObj => {
      this.setState({ pinpad: pinpadObj.pinpad || '' })
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.card?.ID !== this.props.card?.ID) {
      this.getInvoices();
    }
  }

  handleModalHide = () => {
    this.setState({ modalShow: false });
    this.getInvoices();
  };

  handleActualPaySumChange(event) {
    this.setState({ actual_pay_sum: event.target.value }, () => {
      this.setState({
        actual_pay_sum_valid:
          this.state.actual_pay_sum > 0 &&
          this.state.actual_pay_sum <= this.state.inv_sum,
      });
    });
  }

  handlPaymentsNoChange(event) {
    this.setState({ payments_no: event.target.value });
  }

  render() {
    console.log(this.state.rows);
    const hasRows =
      this.state.rows === null || (this.state.rows?.length || 0) === 0
        ? false
        : true;
    const { t } = this.props;
    const { selectedIndexes } = this.state;
    const rowText = selectedIndexes.length === 1 ? t("row") : t("rows");
    const error = this.state.rows?.error || null;
    const message = this.state.rows?.message || null;
    return (
      <div>
        <ToastContainer rtl />
        {error && <div className={"alert alert-danger"}>{message}</div>}
        {!hasRows && (
          <div>
            <h4>{t("no_open_invoices")}</h4>
          </div>
        )}
        {hasRows && (
          <div>
            <span>
              {this.state.selectedIndexes.length} {rowText} {t("selected")},{" "}
              {t("selected_invoices_sum")} :{" "}
              {this.state.inv_sum
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
            </span>
            <div>
              <div
                className={
                  "form-group" +
                  (!this.state.actual_pay_sum ? " has-error" : "")
                }
              >
                <div className="elements-line">
                  <label className="formGrouplabel25" htmlFor="actual_pay_sum">
                    {t("actual_pay_sum")}
                  </label>
                  <input
                    className="formGroupInput15 no-border"
                    style={{ 'min-width': '100px' }}
                    type="text"
                    name="actual_pay_sum"
                    value={this.state.actual_pay_sum.toFixed(2)}
                    onChange={this.handleActualPaySumChange}
                    onFocus={(event) => event.target.select()}
                  />
                  <Link
                    className={
                      this.state.actual_pay_sum_valid
                        ? "pym-link"
                        : "pym-link-disabled"
                    }
                    to=""
                    onClick={this.handlecreateSession}
                  >
                    {t("get_request_token")}
                  </Link>

                  {/* <Link
                                    className={this.state.actual_pay_sum_valid ? "pym-link" : "pym-link-disabled"}
                                    to=""
                                    onClick={this.handlecreateSession} >{t('get_request_token')}{this.state.pinpad}</Link> */}
                </div>
                {this.state.pinpad.length > 0 &&
                  this.state.user.LOGIN_ROLE === "U" &&
                  this.state.actual_pay_sum_valid && (
                    <div className="elements-line">
                      <DropdownButton
                        key={`dropdown-button-drop-down`}
                        id={`dropdown-button-drop-down`}
                        drop="down"
                        variant="primary"
                        title={` pinpad `}
                        onSelect={this.handlePinpadSelect}
                      >
                        {this.state.pinpad.split(",").map((pinpad_id) => (
                          <Dropdown.Item eventKey={pinpad_id}>
                            {pinpad_id}
                          </Dropdown.Item>
                        ))}
                      </DropdownButton>
                      <label className="formGrouplabel50" htmlFor="payments_no">
                        {t("payments_no")}
                      </label>
                      <input
                        className="formGroupInput15 no-border"
                        type="text"
                        name="payments_no"
                        pattern="[0-9]*"
                        value={this.state.payments_no}
                        onChange={this.handlPaymentsNoChange}
                        onFocus={(event) => event.target.select()}
                      />
                    </div>
                  )}
                <p className="colorRed">
                  {!this.state.actual_pay_sum_valid ||
                    t("one_payment_or_credit")}{" "}
                </p>

                {((this.state.actual_pay_sum === 0 &&
                  this.state.inv_sum !== 0) ||
                  this.state.actual_pay_sum > this.state.inv_sum) && (
                    <div className="help-block">
                      {t("actual_pay_sum")} {t("incorrect")}
                    </div>
                  )}
              </div>
            </div>
            <div dir="ltr">
              <ReactDataGrid
                rowKey="id"
                columns={this._columns}
                rowGetter={this.rowGetter}
                rowsCount={this.state.rows.length}
                rowSelection={{
                  showCheckbox: true,
                  enableShiftSelect: true,
                  onRowsSelected: this.onRowsSelected,
                  onRowsDeselected: this.onRowsDeselected,
                  selectBy: {
                    indexes: this.state.selectedIndexes,
                  },
                }}
              />
            </div>
          </div>
        )}
        {this.state.modalShow && (
          <PaymentModal
            show={this.state.modalShow}
            z_credit_url={this.state.zCreditUrl}
            onHide={() => this.handleModalHide()}
          ></PaymentModal>
        )}
      </div>
    );
  }
}

const InvoicesComponent = withTranslation()(InvoicesComponent_);
export { InvoicesComponent };
